import { Injectable, signal } from '@angular/core';
import { MapWithState } from '../store/cop';
import { MapFeatures } from 'src/app/modules/cop/drawing/models/layer-map-features.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapDrawingStateService {
  googleMap: google.maps.Map;
  mapState: MapWithState;
  mapFeatures: MapFeatures = {};
  // this is a temporary solution until map can be rewritten using proper state management conventions
  isInitializing = new BehaviorSubject(false);
  isInitializing$ = this.isInitializing.asObservable();
}
